// Společné kousky Knihy úrazů (15. 10. 2026): stavy, volby, cesty, výběrové čipy.
import React from "react";

export const STAV = {
  koncept: { text: "koncept", ton: "neutralni" },
  ceka_podpis: { text: "čeká na podpis zraněné", ton: "pozor" },
  ceka_projednani: { text: "čeká na projednání", ton: "znacka" },
  uzavreno: { text: "uzavřeno", ton: "ok" },
};
export const TYPY_TRENINKU = [
  { key: "osobni", label: "Osobní trénink" },
  { key: "bootcamp", label: "Bootcamp" },
  { key: "samostatne", label: "Samostatné cvičení" },
  { key: "mimo", label: "Mimo trénink" },
];
export const ZRANENY_TYP = [
  { key: "klientka", label: "Klientka" },
  { key: "trener", label: "Trenér" },
  { key: "jina", label: "Jiná osoba" },
];
export const CASTI_TELA = ["Hlava", "Krk", "Rameno", "Paže", "Loket", "Ruka", "Záda", "Hrudník", "Břicho", "Kyčel", "Stehno", "Koleno", "Lýtko", "Kotník", "Chodidlo"];
export const STRANY = ["Levá", "Pravá", "Obě", "Neurčeno"];
export const DRUHY = ["Podvrtnutí", "Natažení", "Pohmoždění", "Odřenina", "Řezná rána", "Zlomenina", "Nevolnost", "Jiné"];
export const ZACHRANKA = ["Nevolána", "Volána"];
export const LEKAR = ["Nešla", "Šla sama", "Doporučeno", "Odvezena"];

export const POPISEK = "mb-1.5 block text-[13px] font-bold text-slate-700";

/** Cesta ke Knize úrazů podle toho, odkud se otevírá (trenér zůstává ve svém portálu). */
export function zaklad(pathname) {
  return String(pathname || "").startsWith("/trener/") ? "/trener/kniha-urazu" : "/kniha-urazu";
}

export const fmtDatum = (d) => {
  const s = String(d || "").slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return "";
  const [y, m, dd] = s.split("-").map(Number);
  return `${dd}. ${m}. ${y}`;
};
export const fmtKdy = (iso) => (iso ? new Date(iso).toLocaleString("cs-CZ", { timeZone: "Europe/Prague", day: "numeric", month: "numeric", hour: "2-digit", minute: "2-digit" }) : "");

/** Výběrové čipy. Vybraný je poznat podle barvy (bez fajfky, Láďa 15. 10. 2026). */
export function Cipy({ volby, hodnota, onChange, nazev }) {
  return (
    <div className="flex flex-wrap gap-2" role="group" aria-label={nazev}>
      {volby.map((v) => {
        const key = typeof v === "string" ? v : v.key;
        const label = typeof v === "string" ? v : v.label;
        const zap = hodnota === key;
        return (
          <button key={key} type="button" aria-pressed={zap} onClick={() => onChange(zap ? null : key)}
            className={`min-h-[44px] rounded-full border px-3.5 text-sm font-bold transition ${zap ? "border-brand-300 bg-brand-100 text-brand-deep" : "border-slate-200 bg-white text-slate-600 hover:border-brand-300"}`}>
            {label}
          </button>
        );
      })}
    </div>
  );
}
